module.exports = __webpack_public_path__ + "908e4d2e/img/menu-icon.5f8facae.svg";